/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateAuthorModelSchema } from "../createOrUpdateAuthorModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const putApiAuthorsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор автора.")
    })

/**
 * @description Идентификатор обновляемого автора
 */
export const putApiAuthorsId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации | Автор уже существует
 */
export const putApiAuthorsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiAuthorsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiAuthorsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Автор не найден
 */
export const putApiAuthorsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiAuthorsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса.
 */
export const putApiAuthorsIdMutationRequestSchema = z.lazy(() => createOrUpdateAuthorModelSchema).describe("Тело запроса.")

export const putApiAuthorsIdMutationResponseSchema = z.lazy(() => putApiAuthorsId200Schema)